import aboutimg from '../images/about.jpeg'
import Title from './Title'
const About = () => {
  return (
    <section className="section" id="about">
      <Title title="About" subTitle="Us" />

      <div className="section-center about-center">
        <div className="about-img">
          <img src={aboutimg} className="about-photo" alt="awesome beach" />
        </div>
        <article className="about-info">
          <h3>explore the difference</h3>
          <p>
            𝙰𝚝 𝙱𝚊𝚌𝚔𝚛𝚘𝚊𝚍𝚜, 𝚠𝚎 𝚋𝚎𝚕𝚒𝚎𝚟𝚎 𝚝𝚑𝚊𝚝 𝚝𝚛𝚊𝚟𝚎𝚕 𝚜𝚑𝚘𝚞𝚕𝚍 𝚋𝚎 𝚖𝚘𝚛𝚎 𝚝𝚑𝚊𝚗 𝚓𝚞𝚜𝚝 𝚊 𝚠𝚊𝚢
            𝚝𝚘 𝚎𝚜𝚌𝚊𝚙𝚎 𝚝𝚑𝚎 𝚛𝚘𝚞𝚝𝚒𝚗𝚎 𝚘𝚏 𝚎𝚟𝚎𝚛𝚢𝚍𝚊𝚢 𝚕𝚒𝚏𝚎. 𝚆𝚎 𝚋𝚎𝚕𝚒𝚎𝚟𝚎 𝚝𝚑𝚊𝚝 𝚝𝚛𝚊𝚟𝚎𝚕 𝚑𝚊𝚜
            𝚝𝚑𝚎 𝚙𝚘𝚠𝚎𝚛 𝚝𝚘 𝚌𝚑𝚊𝚗𝚐𝚎 𝚙𝚎𝚘𝚙𝚕𝚎'𝚜 𝚕𝚒𝚟𝚎𝚜, 𝚋𝚛𝚘𝚊𝚍𝚎𝚗 𝚝𝚑𝚎𝚒𝚛 𝚑𝚘𝚛𝚒𝚣𝚘𝚗𝚜, 𝚊𝚗𝚍
            𝚌𝚘𝚗𝚗𝚎𝚌𝚝 𝚝𝚑𝚎𝚖 𝚝𝚘 𝚗𝚎𝚠 𝚌𝚞𝚕𝚝𝚞𝚛𝚎𝚜 𝚊𝚗𝚍 𝚎𝚡𝚙𝚎𝚛𝚒𝚎𝚗𝚌𝚎𝚜. 𝚃𝚑𝚊𝚝'𝚜 𝚠𝚑𝚢 𝚠𝚎'𝚛𝚎
            𝚍𝚎𝚍𝚒𝚌𝚊𝚝𝚎𝚍 𝚝𝚘 𝚙𝚛𝚘𝚟𝚒𝚍𝚒𝚗𝚐 𝚘𝚞𝚛 𝚌𝚕𝚒𝚎𝚗𝚝𝚜 𝚠𝚒𝚝𝚑 𝚞𝚗𝚏𝚘𝚛𝚐𝚎𝚝𝚝𝚊𝚋𝚕𝚎 𝚝𝚛𝚊𝚟𝚎𝚕
            𝚎𝚡𝚙𝚎𝚛𝚒𝚎𝚗𝚌𝚎𝚜 𝚝𝚑𝚊𝚝 𝚊𝚛𝚎 𝚋𝚘𝚝𝚑 𝚊𝚞𝚝𝚑𝚎𝚗𝚝𝚒𝚌 𝚊𝚗𝚍 𝚜𝚞𝚜𝚝𝚊𝚒𝚗𝚊𝚋𝚕𝚎.
          </p>
          <p>
            𝚆𝚒𝚝𝚑 𝚘𝚞𝚛 𝚎𝚡𝚙𝚎𝚛𝚝 𝚐𝚞𝚒𝚍𝚎𝚜 𝚊𝚗𝚍 𝚌𝚊𝚛𝚎𝚏𝚞𝚕𝚕𝚢 𝚌𝚞𝚛𝚊𝚝𝚎𝚍 𝚒𝚝𝚒𝚗𝚎𝚛𝚊𝚛𝚒𝚎𝚜, 𝚠𝚎 𝚘𝚏𝚏𝚎𝚛
            𝚞𝚗𝚒𝚚𝚞𝚎 𝚘𝚙𝚙𝚘𝚛𝚝𝚞𝚗𝚒𝚝𝚒𝚎𝚜 𝚝𝚘 𝚎𝚡𝚙𝚕𝚘𝚛𝚎 𝚝𝚑𝚎 𝚠𝚘𝚛𝚕𝚍'𝚜 𝚖𝚘𝚜𝚝 𝚎𝚡𝚌𝚒𝚝𝚒𝚗𝚐
            𝚍𝚎𝚜𝚝𝚒𝚗𝚊𝚝𝚒𝚘𝚗𝚜 𝚠𝚑𝚒𝚕𝚎 𝚊𝚕𝚜𝚘 𝚐𝚒𝚟𝚒𝚗𝚐 𝚋𝚊𝚌𝚔 𝚝𝚘 𝚝𝚑𝚎 𝚌𝚘𝚖𝚖𝚞𝚗𝚒𝚝𝚒𝚎𝚜 𝚠𝚎 𝚟𝚒𝚜𝚒𝚝.
            𝙹𝚘𝚒𝚗 𝚞𝚜 𝚘𝚗 𝚊 𝚓𝚘𝚞𝚛𝚗𝚎𝚢 𝚝𝚑𝚊𝚝 𝚠𝚒𝚕𝚕 𝚒𝚗𝚜𝚙𝚒𝚛𝚎 𝚢𝚘𝚞 𝚊𝚗𝚍 𝚝𝚛𝚊𝚗𝚜𝚏𝚘𝚛𝚖 𝚝𝚑𝚎 𝚠𝚊𝚢 𝚢𝚘𝚞
            𝚜𝚎𝚎 𝚝𝚑𝚎 𝚠𝚘𝚛𝚕𝚍.
          </p>
          <a href="#about" className="btn" rel="noreferrer">
            read more
          </a>
        </article>
      </div>
    </section>
  )
}
export default About
